export async function execute(args, context) {
  const { iframeRef } = context;
  const { action, selector } = args;

  if (!iframeRef?.current?.contentWindow?.document) {
    return {
      success: false,
      error: 'Page preview not available'
    };
  }

  const doc = iframeRef.current.contentWindow.document;

  if (action === 'tree') {
    return getDOMTree(doc);
  }

  if (action === 'element') {
    if (!selector) {
      return {
        success: false,
        error: 'Selector required for "element" action'
      };
    }
    return getElementHTML(doc, selector);
  }

  return {
    success: false,
    error: `Unknown action: ${action}`
  };
}

// SVG elements expose className as SVGAnimatedString, not a string, so reading
// the attribute directly is the only safe way to get a class string for both.
const classAttr = (el) => el.getAttribute('class') || '';

function getDOMTree(doc) {
  const result = [];

  function traverse(element) {
    if (!element || element.nodeType !== 1) return;
    if (element.id === 'tiiny-style') return;

    const tag = element.tagName.toLowerCase();
    const cls = classAttr(element);
    const classes = cls
      ? `.${cls.split(' ').filter(c => c && !c.startsWith('tiiny')).join('.')}`
      : '';
    const id = element.id && !element.id.startsWith('tiiny') ? `#${element.id}` : '';
    const selector = `${tag}${id}${classes}`;

    const children = [];
    for (let i = 0; i < element.children.length; i++) {
      const child = element.children[i];
      if (child.id === 'tiiny-style') continue;

      const childTag = child.tagName.toLowerCase();
      const childCls = classAttr(child);
      const childClasses = childCls
        ? `.${childCls.split(' ').filter(c => c && !c.startsWith('tiiny')).join('.')}`
        : '';
      const childId = child.id && !child.id.startsWith('tiiny') ? `#${child.id}` : '';
      children.push(`${childTag}${childId}${childClasses}`);
    }

    if (children.length > 0) {
      result.push(`${selector} > ${children.join(', ')}`);
    } else {
      result.push(selector);
    }

    for (let i = 0; i < element.children.length; i++) {
      traverse(element.children[i]);
    }
  }

  traverse(doc.body);

  return {
    success: true,
    tree: result.join('\n')
  };
}

function getElementHTML(doc, selector) {
  try {
    const elements = doc.querySelectorAll(selector);

    if (elements.length === 0) {
      return {
        success: false,
        error: `No element found for selector: ${selector}`
      };
    }

    if (elements.length === 1) {
      return {
        success: true,
        selector,
        html: elements[0].outerHTML,
        tagName: elements[0].tagName.toLowerCase()
      };
    }

    // Multiple elements
    return {
      success: true,
      selector,
      count: elements.length,
      elements: Array.from(elements).slice(0, 5).map((el, i) => ({
        index: i,
        tagName: el.tagName.toLowerCase(),
        html: el.outerHTML.length > 200 ? el.outerHTML.slice(0, 200) + '...' : el.outerHTML
      })),
      note: elements.length > 5 ? `Showing first 5 of ${elements.length} elements` : undefined
    };
  } catch (err) {
    return {
      success: false,
      error: `Invalid selector: ${err.message}`
    };
  }
}
